export class TextInput {

    constructor (private textContainer:JQuery) {
        textContainer.find('.form-text-clear').on("click",()=>this.clearEvent());
        textContainer.find('.form-text-info').on("click",()=>this.infoEvent());
    }

    public hasAutoSubmit() {
        var form=this.textContainer.closest("form");
        if (!form.length) return false;
        if (form.attr("data-autosubmit")=="off") return false;
        var select=this.textContainer.find("select");
        return select.attr("data-autosubmit")!="off";
    }

    public submit() {
        var form=this.textContainer.closest("form");
        if (!form.find("[type=submit]:visible").length && this.hasAutoSubmit()) {
            var btn=form.find("[type=submit]");
            if (btn.length) btn.click(); else form.submit();
        }
        var input=this.textContainer.find("input");
        input.trigger("change","internal");
    }

    private infoEvent() {
        let description=this.textContainer.find("input").attr('aria-description');
        this.textContainer.find(".aria").toggleClass('visible');
    }

    private clearEvent() {
        this.textContainer.find("input").val("").focus().trigger("input").trigger("clear");
        this.submit();
    }

}

export {};